import actions from './actions';
import types from './mutation-types';
import store from '@/store';

const messageTypes = [
	'primary',
	'secondary',
	'success',
	'danger',
	'warning',
	'info',
	'light',
	'dark'
];

const setMessageType = (type) => {
	if (messageTypes.indexOf(type)) {
		return type;
	} else {
		return messageTypes[0];
	}
}

const state = {
	messages: [],
	messageIdCounter: 0
};

const getters = {
	flashMessages(state) {
		return state.messages.filter((message) => message.pages == 0);
	}
};

const mutations = {
	[types.NEXT_PAGE](state, payload) {
		state.messages = state.messages
			.map((message) => Object.assign({}, message, { pages: message.pages - 1 }))
			.filter((message) => message.pages >= 0);
	},
	[types.ADD_FLASH_MESSAGE](state, payload) {
		state.messageIdCounter++;

		const message = {
			pages: parseInt(payload.pages) || 0,
			id: state.messageIdCounter,
			type: setMessageType(payload.type),
			message: payload.message
		};

		state.messages.push(message);
	}
};


// exports
export const hookFlashMessagesAtRouter = (router) => {
	router.afterEach((to, from) => {
		store.dispatch('flashMessages/nextPage', { to: to, from: from });
	})
}

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/flash-messages/index.js